import { useContext } from 'react'

import { UserContext, type UserContextValue } from '../providers/UserContext'

export function useUser(): UserContextValue {
  const ctx = useContext(UserContext)

  if (!ctx) {
    throw new Error('useUser must be inside UserContextProvider')
  }
  return ctx
}
